import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ThemesPage from './pages/ThemesPage.tsx';
function App() {
  return (
    <div className="App">
    <ThemesPage/>
    </div>
  );
}

export default App;
